import { render, staticRenderFns } from "./ArgicProduct.vue?vue&type=template&id=680a7578&scoped=true"
import script from "./ArgicProduct.vue?vue&type=script&lang=js"
export * from "./ArgicProduct.vue?vue&type=script&lang=js"
import style0 from "./ArgicProduct.vue?vue&type=style&index=0&id=680a7578&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680a7578",
  null
  
)

export default component.exports